import { render, staticRenderFns } from "./TreatmentResumeForm.vue?vue&type=template&id=5294f548"
import script from "./TreatmentResumeForm.vue?vue&type=script&lang=js"
export * from "./TreatmentResumeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports